module.exports = __webpack_public_path__ + "img/MapPicsHillfort.856976eb.webp";